export default "__VITE_ASSET__vkPUC7up__"